export function getLatestIteration(names: string[], baseName: string) {
	const regex = new RegExp(`^${baseName}_(\\d+)$`);
	let maxIteration = -1;

	for (const name of names) {
		const match = name.match(regex);
		if (match) {
			const iteration = parseInt(match[1], 10);
			if (iteration > maxIteration) {
				maxIteration = iteration;
			}
		}
	}

	return maxIteration;
}

export function getNextIteration(names: string[], baseName: string) {
	const latestIteration = getLatestIteration(names, baseName);

	return `${baseName}_${latestIteration + 1}`;
}

export function getBaseName(name: string) {
	if (/^\d+$/.test(name)) {
		return null
	}
	const regex = /^(.*?)(?:_(\d+)(?:_.*)?)?$/;
	const match = regex.exec(name);
	if (!match) {
		return null
	}
	const baseName = match?.[1] ?? ""
	const firstDigit = match?.[2] ?? "0"
	return `${baseName}_${firstDigit}`
}
